import { useEffect, useState } from "react";
import { useParams, Link, Navigate } from "react-router-dom";
import { Show } from "@clerk/react";
import { ChevronLeft, Play } from "lucide-react";
import Nav from "@/components/Nav";
import ShareButton from "@/components/ShareButton";
import { publicApi } from "@/lib/api";

export default function CategoryPage() {
  const { id } = useParams();
  const [quizzes, setQuizzes] = useState([]);
  const [cat, setCat] = useState(null);

  useEffect(() => {
    publicApi.get("/categories").then((r) => setCat(r.data.find((c) => c.id === id) || null));
    publicApi.get(`/categories/${id}/quizzes`).then((r) => setQuizzes(r.data));
  }, [id]);

  return (
    <>
      <Show when="signed-out"><Navigate to="/sign-in" replace /></Show>
      <Show when="signed-in">
        <Nav />
        <main className="max-w-5xl mx-auto px-4 py-10">
          <Link to="/play" className="inline-flex items-center gap-1 font-bold text-slate-700 hover:underline mb-6" data-testid="back-dashboard">
            <ChevronLeft size={18} strokeWidth={2.5} /> Back to categories
          </Link>
          <h1 className="text-4xl font-black tracking-tight">{cat?.name || "Category"}</h1>
          <p className="text-slate-600 mt-1">{cat?.description}</p>

          <div className="mt-8 grid gap-4" data-testid="quizzes-list">
            {quizzes.map((q) => (
              <div key={q.id} className="sticker p-5 flex items-center justify-between gap-4">
                <div>
                  <h3 className="text-xl font-black tracking-tight">{q.title}</h3>
                  <p className="text-slate-600">{q.description}</p>
                  {!q.is_free && <span className="inline-block mt-1 text-xs font-black px-2 py-0.5 rounded-full border-[2px] border-[#374151] bg-[var(--tp-accent)]">Community</span>}
                </div>
                <div className="shrink-0 flex items-center gap-2">
                <ShareButton path={`/quiz/${q.id}`} label="Share" testid={`share-quiz-${q.id}`} title={q.title} />
                <Link to={`/quiz/${q.id}`} data-testid={`play-quiz-${q.id}`}
                  className="shrink-0 px-5 py-2.5 rounded-full border-[3px] border-[#374151] bg-[var(--tp-success)] text-white font-black shadow-[0_4px_0_0_#374151] active:translate-y-1 active:shadow-none inline-flex items-center gap-1">
                  <Play size={16} strokeWidth={2.5} /> Play
                </Link>
                </div>
              </div>
            ))}
            {quizzes.length === 0 && <p className="text-slate-500">No quizzes yet in this category.</p>}
          </div>
        </main>
      </Show>
    </>
  );
}
